<div class="get-care-now-title-container-mobile">{{title}}</div>
<div class="get-care-now-description-container-mobile">
    <div>{{description}}</div>
</div>
<div *ngIf="inpersonUrgentCareOptions != null && inpersonUrgentCareOptions.length > 0" class="get-care-now-scroll-container-mobile">
    <app-in-person-urgent-care-option-card-mobile
      *ngFor="let option of inpersonUrgentCareOptions; let i = index"
      [providerId]="option.providerId"
      [departmentId]="option.departmentId"
      [name]="option.city"
      [photo]="option.photo"
      [waitTime]="option.waitTime"
      [nextAvailability]="option.nextAvailability"
      [isOpen]="option.isOpen"
      [address]="option.fullAddress"
      [distance]="option.distanceInMiles"
      [isPlus]="isPlus"
      [locale]="locale"
      [ngStyle]="i === 0 ? {'margin-left': '16px'} : {}">
    </app-in-person-urgent-care-option-card-mobile>
    <div>
        <mat-card class="get-care-now-show-more-card-mobile" appearance="outlined" style="text-align: center;" (click)="showMeMore()">
            <div class="get-care-now-show-more-button-mobile">{{showMoreText}}</div>
        </mat-card>
    </div>
</div>
<div *ngIf="!inpersonUrgentCareOptions || inpersonUrgentCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>